import { useState } from 'react';
import Form from '../../layouts/Form';
import OrderForm from './OrderForm';
import Modal from '../Reusable/Modal';
import CreateCustomer from './CreateCustomerForm';
import { useForm, useFieldArray } from "react-hook-form";

const EditOrder = (props: any) => {
  const [openAddReceiverPopup, setOpenAddReceiverPopup] = useState(false)
  const [openAddSenderPopup, setOpenAddSenderPopup] = useState(false)
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    watch,
    getValues,
    clearErrors
  } = useForm<any>({
    defaultValues: async () => {
      let order = props?.order
      return {
        pickup_branch: order.pickup_branch,
        destination: order?.destination,
        vendor: order?.merchant,
        sender: order?.sender,
        receiver: order?.receiver,
        service_type: order?.service_type,
        payment_method: order?.payment_method,
        reference_type: order?.reference_type,
        reference_date: order?.reference_date,
        reference_number: order?.reference_number,
        order_value: order?.order_value,
        cod: order?.cod,
        note: order?.note,
        order_items: order?.children?.map((item: any, index: number) => ({
          package_type: { ...item.package_type },
          piece: item?.piece,
          weight: item?.weight
        }))
      }
    }
  });
  const { handleEdit, isLoading, handleCreateCustomer, createCustomerLoading } = props;

  const { fields, append, remove } = useFieldArray({
    control,
    name: "order_items"
  });

  return (
    <>
      <Form
        handleSubmit={handleSubmit}
        handleFormSubmit={handleEdit}
        setError={setError}
        buttonLabel={"Update"}
        isLoading={isLoading}
      >
        <OrderForm
          clearErrors={clearErrors}
          errors={errors}
          register={register}
          setValue={setValue}
          getValues={getValues}
          watch={watch}
          openAddReceiverPopup={openAddReceiverPopup}
          setOpenAddReceiverPopup={setOpenAddReceiverPopup}
          openAddSenderPopup={openAddSenderPopup}
          setOpenAddSenderPopup={setOpenAddSenderPopup}
          fields={fields}
          append={append}
          remove={remove}
        />
      </Form>
      <Modal
        isOpen={openAddReceiverPopup}
        setIsOpen={setOpenAddReceiverPopup}
        title={"Craeate Receiver"}
        children={<>
          <CreateCustomer
            handleCreate={handleCreateCustomer}
            isLoading={createCustomerLoading}
          />
        </>} />
      <Modal
        isOpen={openAddSenderPopup}
        setIsOpen={setOpenAddSenderPopup}
        title={"Create Sender"}
        children={<>
          <CreateCustomer
            handleCreate={handleCreateCustomer}
            isLoading={createCustomerLoading}
          />
        </>} />
    </>


  )
}

export default EditOrder
